export function getAudioDurationFromUrl(url: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();

    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration);
    });

    audio.addEventListener('error', (e) => {
      reject(new Error('Failed to load audio metadata'));
    });

    audio.src = url;
    audio.load();
  });
}
